/** Matches schedules/[scheduleId]/page two-column shell */
export default function ScheduleDetailPageSkeleton() {
  return (
    <div
      className="skeleton-stage w-full p-8 flex flex-col gap-8 max-w-[1200px] mx-auto"
      aria-busy
      aria-label="Loading"
    >
      <div className="flex justify-center items-start gap-8 flex-col lg:flex-row">
        <div className="w-full lg:w-[520px] self-stretch pt-8 bg-white rounded-3xl flex flex-col gap-6 p-6 min-h-[480px]">
          <div className="flex flex-col items-center gap-4">
            <div className="h-28 w-28 rounded-full skeleton-shimmer" />
            <div className="h-6 w-48 skeleton-shimmer rounded" />
            <div className="h-4 w-32 skeleton-shimmer rounded" />
          </div>
          <div className="space-y-3">
            <div className="h-3 w-full skeleton-shimmer rounded" />
            <div className="h-3 w-full skeleton-shimmer rounded" />
            <div className="h-3 w-[80%] max-w-full skeleton-shimmer rounded" />
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-10 w-28 rounded-md skeleton-shimmer" />
            ))}
          </div>
        </div>
        <div className="flex-1 w-full min-w-0 space-y-6">
          <div className="h-10 w-full skeleton-shimmer rounded-lg" />
          <div className="h-32 w-full skeleton-shimmer rounded-xl" />
          <div className="h-40 w-full skeleton-shimmer rounded-xl" />
        </div>
      </div>
    </div>
  );
}
